import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const facebookFormRoot = (state: State) => state.facebookForm;

export const facebookFormsSelector = createSelector(facebookFormRoot, (me) => me.facebookForms.forms);
export const facebookFormSelector = createSelector(facebookFormRoot, (me) => me.facebookForm);
